import LogoutIcon from '@mui/icons-material/Logout';
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { Translate } from 'react-jhipster';
import { useHistory } from 'react-router-dom';
import { LogoutConfirmationModal } from './LogoutConfirmModal';

export interface ILogoutMenu {
  isAuthenticated: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const Logout = (props: ILogoutMenu) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const history = useHistory();

  const handleConfirm = () => {
    history.push('/logout');
    setOpenModal(false);
  };

  return (
    <>
      <Tooltip title={props.drawerIsOpen ? '' : <Translate contentKey="global.menu.account.logout">Sign out</Translate>} placement="right">
        <ListItemButton
          onClick={() => setOpenModal(true)}
          sx={{
            pl: { xs: '18px', md: '32px' },
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.account.logout">Sign out</Translate>}
            primaryTypographyProps={{
              fontWeight: props.isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
        </ListItemButton>
      </Tooltip>
      <LogoutConfirmationModal open={openModal} onClose={() => setOpenModal(false)} onConfirm={handleConfirm} />
    </>
  );
};
